// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.text-center[data-v-45ae7493] {\r\n    text-align: center;\n}\n.text-start[data-v-45ae7493] {\r\n    text-align: left;\n}\n.full-width-select[data-v-45ae7493] {\r\n    width: 100%;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    padding-right: 10px;\r\n    margin-bottom: 15px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
